import { createFileRoute } from '@tanstack/react-router';
import { Notifications } from '@/features/cleaner/notifications';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { Badge } from '@/components/ui/badge';
import { useGetNotificationsUnreadCountQuery } from '@/hooks/queries/use-get-notifications-unread-count.query';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/notifications'
)({
  component: NotificationsPage,
});

function NotificationsPage() {
  const { data: unreadCountData } = useGetNotificationsUnreadCountQuery();
  const unreadCount = unreadCountData?.data?.unread_count || 0;

  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>
          Notifications
          {unreadCount > 0 && (
            <Badge variant="destructive">
              {unreadCount > 9 ? '9+' : unreadCount}
            </Badge>
          )}
        </HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <Notifications />
      </div>
    </div>
  );
}
